import { Component, OnDestroy, OnInit } from '@angular/core';
import { UtilsService } from 'src/app/utils/utils.service';
import { DataService } from 'src/app/main/shared/services/data.service';
import { isNullOrUndefined } from 'util';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AgricultureMapConstants } from 'src/app/main/constants/dims-map-constants';

@Component({
  selector: 'app-seasonal-temp-sidebar',
  templateUrl: './seasonal-temp-sidebar.component.html',
  styleUrls: ['./seasonal-temp-sidebar.component.scss']
})
export class SeasonalTempSidebarComponent implements OnInit, OnDestroy {

  queryParams: any = {};
  destroy: any = new Subject();

  constructor(
    private utils: UtilsService,
    private dataService: DataService
  ) { }

  ngOnInit() {
    this.subscribeEvents();
    if (!this.isSeasonalTempParams(this.queryParams)) {
      this.requestSelectedParams();
    }
  }

  subscribeEvents() {
    this.utils.selectedParams.pipe(takeUntil(this.destroy)).subscribe((params: any) => {
      let sessionStorageSelectedParams: any = sessionStorage.getItem('params');
      if (Object.keys(params).length > 0) {
        this.queryParams = params;
      } else {
        this.queryParams = sessionStorageSelectedParams ? JSON.parse(sessionStorageSelectedParams) : {};
        if (this.isSeasonalTempParams(this.queryParams)) {
          this.utils.setSelectedParams(this.queryParams);
        }
      }
    });
  }

  isSeasonalTempParams(params: any) {
    return !isNullOrUndefined(params) && params.component == AgricultureMapConstants.COMPONENT.SEASONALTEMP;
  }

  // Default view: the user's own location (India for national users), as in the other Heat modules
  requestSelectedParams() {
    let metaInfo: any = localStorage.getItem('metaInfo');
    let metaInfoJson: any = !isNullOrUndefined(metaInfo) ? JSON.parse(metaInfo) : {};
    if (!metaInfoJson.userDetailsJson) {
      return;
    }
    const userLocationConfig = this.dataService.formQuerParamsVariables(metaInfoJson.userDetailsJson.data.location, metaInfoJson.userDetailsJson.data.locType);
    const currentLocations: any = userLocationConfig.locationInfo[userLocationConfig.types.pType.toLowerCase()].split('##');
    this.utils.setSelectedParams({
      component: AgricultureMapConstants.COMPONENT.SEASONALTEMP,
      actionType: 'filter',
      view: 'Admin',
      dashboardView: 'INDIA',
      dashboardType: 'gis',
      pUUID: currentLocations[1],
      locName: currentLocations[0],
      locType: userLocationConfig.types.pType,
      pEUUID: userLocationConfig.locationInfo.country.split('##')[1],
      location: userLocationConfig.locationInfo.location
    });
  }

  ngOnDestroy() {
    this.destroy.next();
    this.destroy.complete();
  }
}
